var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#tiktok_svg__a)",
    d: "M22.214 4.857A7.218 7.218 0 0 1 20.321 0h-5.517v21.356a4.394 4.394 0 0 1-1.412 3.053 4.72 4.72 0 0 1-3.213 1.252c-2.536 0-4.643-1.998-4.643-4.478 0-2.962 2.964-5.184 6.018-4.27V11.47C5.393 10.678 0 15.293 0 21.183 0 26.918 4.929 31 10.16 31c5.608 0 10.161-4.392 10.161-9.817V10.351A13.457 13.457 0 0 0 28 12.727V7.406s-3.357.155-5.786-2.55Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tiktok_svg__a",
    x1: 4.891,
    x2: 21.789,
    y1: 2.528,
    y2: 2.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505,
    stopColor: "#F0CAB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC836D"
  })))));
};
export default SvgTiktok;